<template>
	<template v-if="badge === Badge.CZ_PRODUCT">
		<NuxtIcon name="custom/czFlag" class="text-3xl" filled />
	</template>
	<template v-if="badge === Badge.AGE_LIMIT">
		<div class="rem:w-[32px] rem:h-[32px] bg-red rounded-full flex items-center justify-center text-body-inverse ont-bold typo-body-s">
			{{ ageLimitation }}+
		</div>
	</template>
	<template v-if="badge === Badge.SECURITY_TAG">
		<NuxtIcon name="custom/securityTag" class="text-3xl" filled />
	</template>
	<template v-if="badge === Badge.MORE_VARIANTS">
		<NuxtIcon name="custom/moreVariants" class="text-3xl" filled />
	</template>
</template>

<script setup lang="ts">
	import {Badge} from '@/types/product';

	interface Props {
		badge: string,
		ageLimitation?: number | null
	}

	defineProps<Props>();
</script>
